import { gql } from 'graphql-tag';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';

export default gql`
    fragment EventSummaryFragment on Event {
        dek
        title
        path
        hero {
            image {
                ...ImageSummaryFragment
            }
        }
        contributors {
            ...PersonSummaryFragment
        }
        contentType: subtype
        eventDate {
            startDate
            startTime
            endDate
            endTime
            timeZone
        }
    }
    ${ImageSummaryFragment}
    ${PersonSummaryFragment}
`;
